import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MoreInformationDialogComponent } from '@app/dialogs/genericDialogs/moreInformationDialog/moreInformation';
import { SharedPipeModule } from '@app/shared/pipes/shared.pipe.module';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { StorageService } from '@services/Logic/storage.service';

@Component({
  selector: 'app-cancellation-guardrail',
  standalone: true,
  imports: [MatIconModule, SharedPipeModule],
  templateUrl: './cancellationGuardrail.component.html',
  styleUrls: ['./cancellationGuardrail.component.scss'],
})
export class CancellationGuardrailComponent {
  constructor(
    private dialog: MatDialog,
    private t: TranslatePipe,
    private storage: StorageService,
  ) {}

  public openCancellationGuardrail() {
    this.dialog.open(MoreInformationDialogComponent, {
      panelClass: 'full-screen-modal-mobile',
      width: '500px',
      data: {
        title: this.t.transform(
          'DIALOGS.INFORMATION.CANCELLATION_POLICY.TASKER.RELIABILITY',
        ),
        subLine: this.t.transform(
          'DIALOGS.INFORMATION.CANCELLATION_POLICY.TASKER.ACC_RISK_HEADLINE',
        ),
        description: this.t.transform(
          'DIALOGS.INFORMATION.CANCELLATION_POLICY.TASKER.ACC_RISK',
        ),
        completionRate: this.storage?.user?.completionRate,
      },
    });
  }
}
